import { render, staticRenderFns } from "./DynamicFooter.vue?vue&type=template&id=24045084&scoped=true"
import script from "./DynamicFooter.vue?vue&type=script&lang=js"
export * from "./DynamicFooter.vue?vue&type=script&lang=js"
import style0 from "./DynamicFooter.vue?vue&type=style&index=0&id=24045084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24045084",
  null
  
)

export default component.exports